import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import Api from 'src/services/ApiService';
import { CommonAxiosResponse } from 'src/types';
import { GetPaymentTypeResponse } from './types';

export const getPaymentTypesThunk = createAsyncThunk<
  CommonAxiosResponse<GetPaymentTypeResponse>,
  undefined,
  { state: RootState }
>('sales/getPaymentTypes', async () => {
  const response = await Api?.get('/sales/payment/types/get');

  if (!response?.success) {
    throw new Error('Failed getPaymentTypesThunk');
  }

  return response;
});
